import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithImpersonationToken } from '@/lib/impersonation';
import { Loading } from '@/components/ui';

function readTokenFromHash(): string | null {
  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  const params = new URLSearchParams(hash);
  return params.get('token');
}

export function ImpersonatePage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let disposed = false;

    const start = async () => {
      const token = readTokenFromHash();
      window.history.replaceState(null, '', '/impersonate');

      if (!token) {
        setError('代理ログイントークンが見つかりません');
        return;
      }

      try {
        const impersonation = await signInWithImpersonationToken(token);
        if (!impersonation) {
          throw new Error('代理ログイン情報を確認できませんでした');
        }
        if (!disposed) {
          navigate('/dashboard', { replace: true });
        }
      } catch (signInError) {
        console.error('Impersonation sign-in failed:', signInError);
        if (!disposed) {
          setError('代理ログインに失敗しました。管理画面から再度実行してください。');
        }
      }
    };

    void start();

    return () => {
      disposed = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#E0DBD2] px-4">
        <div className="w-full max-w-md rounded-3xl bg-white p-6 text-center shadow-sm">
          <p className="text-sm font-semibold text-red-600">{error}</p>
        </div>
      </div>
    );
  }

  return <Loading fullScreen message="代理ログイン中..." />;
}
